import React from 'react'
import { Footer, Navbar } from "../components";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">About Us</h1>
        <hr />
        <p className="lead text-center">
        Balvindra Instruments Corporation, founded in 1971, has been a trusted name in the scientific instruments industry for more than four decades. Guided by a commitment to quality and reliability, we ensure that every product meets the highest standards of precision and durability. Serving laboratories, research facilities, and educational institutions, our diverse range of scientific instruments is designed to empower professionals, educators, and researchers with the accuracy and consistency they need to excel.
        </p>

        <h2 className="text-center py-4">Our Products</h2>
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://balco-public.s3.us-east-1.amazonaws.com/assets/product-images/microscope.png" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Student Microscopes</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://balco-public.s3.us-east-1.amazonaws.com/assets/product-images/microscope.png" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Research Microscopes</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://balco-public.s3.us-east-1.amazonaws.com/assets/product-images/microscope.png" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Laboratory Microscopes</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://balco-public.s3.us-east-1.amazonaws.com/assets/product-images/microscope.png" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Scientific Instruments</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutPage